var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const Resize = (_a) => {
    var { color = "#C1C7D0", size } = _a, props = __rest(_a, ["color", "size"]);
    return (React.createElement("svg", Object.assign({}, props, { width: size, height: size, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("line", { x1: "0.707107", y1: "5", x2: "6", y2: "10.2929", stroke: color, strokeLinecap: "round" }),
        React.createElement("line", { x1: "0.707107", y1: "1", x2: "10", y2: "10.2929", stroke: color, strokeLinecap: "round" })));
};
//# sourceMappingURL=Resize.js.map